module.exports = __webpack_public_path__ + "static/media/identidad_lines.7d411525.png";